import * as Sentry from '@sentry/browser';
import { config } from '../../config';

const UNDEFINED_TOKEN = 'CREATE_RIO_FRONTEND_';

let isSentryInitialized = false;

if (import.meta.env.PROD) {
    // version and environment are defined in the webpack.define plugin
    const release = config.serviceVersion;
    const environment = config.serviceEnvironment;
    const dsn = config.sentryToken;

    const hasToken = !!dsn && !dsn?.startsWith(UNDEFINED_TOKEN);

    if (hasToken) {
        isSentryInitialized = true;
        Sentry.init({
            dsn,
            environment,
            release,
        });
    }
}

export const reportErrorToSentry =
    import.meta.env.PROD && isSentryInitialized
        ? (...args: Parameters<typeof Sentry.captureException>) => Sentry.captureException(...args)
        : () => '';

export const logMessageToSentry = (
    msg: string,
    tags?: {
        [key: string]: string;
    }
) => {
    if (import.meta.env.PROD) {
        Sentry.captureMessage(msg, { tags });
    }
};
